const SAME_DOCUMENT_HASH_PREFIXES = new Set(['', '.', './', '/']);

const decodeFragment = (value: string) => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

export const isSameDocumentAnchorHref = (href?: string | null, doc?: Document) => {
  const trimmedHref = href?.trim();
  if (!trimmedHref) return false;
  if (trimmedHref.startsWith('#')) return true;

  const hashIndex = trimmedHref.indexOf('#');
  if (hashIndex < 0) return false;

  const pathPart = trimmedHref.slice(0, hashIndex).trim();
  const fragmentPart = trimmedHref.slice(hashIndex + 1).trim();
  if (!fragmentPart || !SAME_DOCUMENT_HASH_PREFIXES.has(pathPart)) return false;
  if (!doc) return true;

  const fragmentId = decodeFragment(fragmentPart);
  return Boolean(doc.getElementById(fragmentId));
};

export const isEditableNavigationHref = (href?: string | null, doc?: Document) => {
  const trimmedHref = href?.trim();
  if (!trimmedHref) return false;
  return !isSameDocumentAnchorHref(trimmedHref, doc);
};
